import type { CommonAddress } from '@wix/ambassador-wix-atlas-service-web/types';
import React, {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
} from 'react';

export type onAddressSelect = (address: CommonAddress) => void;

type AddressAutofill = {
  onAddressSelect: onAddressSelect;
  autocompleteEnabled?: boolean;
};

const AddressAutofillContext = createContext<AddressAutofill>({
  onAddressSelect: () => {},
});

export interface AddressAutofillProviderProps {
  children: ReactNode;
  onAddressSelect: onAddressSelect;
  autocompleteEnabled?: boolean;
}

export const AddressAutofillProvider = ({
  children,
  onAddressSelect,
  autocompleteEnabled,
}: AddressAutofillProviderProps) => {
  const value = useMemo(
    () => ({ onAddressSelect, autocompleteEnabled }),
    [onAddressSelect, autocompleteEnabled],
  );
  return (
    <AddressAutofillContext.Provider value={value}>
      {children}
    </AddressAutofillContext.Provider>
  );
};

export function useAddressAutofill() {
  return useContext(AddressAutofillContext);
}
